function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.686279 2.52356C0.686279 1.41899 1.58171 0.52356 2.68628 0.52356H22.6863C23.7908 0.52356 24.6863 1.41899 24.6863 2.52356V22.5236C24.6863 23.6281 23.7908 24.5236 22.6863 24.5236H2.68628C1.58171 24.5236 0.686279 23.6281 0.686279 22.5236V2.52356Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.08838,
  y: 8.02356,
  width: 9,
  height: 4,
  transform: "rotate(90 6.08838 8.02356)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.8203,
  y: 8.02356,
  width: 9,
  height: 4,
  transform: "rotate(90 11.8203 8.02356)",
  fill: "#444444"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5522,
  y: 8.02356,
  width: 9,
  height: 4,
  transform: "rotate(90 17.5522 8.02356)",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 23.2842,
  y: 8.02356,
  width: 9,
  height: 4,
  transform: "rotate(90 23.2842 8.02356)",
  fill: "#444444"
});

function SvgNowrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowrap);
export default __webpack_public_path__ + "static/media/nowrap.7bea12c0.svg";
export { ForwardRef as ReactComponent };